import Config from '@/config/app.js'
import { isWechat } from '@/utils/isTerminal.js'
import { shortUrl, loginWx } from '@/api/shareH5.js'

export default {
    data() {
        return {
            wechatCode: '', // 微信code
            loginSuccess: false, // 是否登陆
        }
    },
    created() {
        // 获取微信code
        if (isWechat) {
            let { code } = PAGE_PARAMS;
            if (code) {
                this.wechatCode = code;
                // 根据sessionToken 判断是否需要登陆
                let sessionCode = sessionStorage.getItem('sessionCode');
                if (sessionCode) {
                    this.loginSuccess = true;
                    return;
                }
                loginWx({code: code, web: 1}).then(r => {
                    this.loginSuccess = r.loginSuccess;
                    sessionStorage.setItem('sessionCode', code);
                    if (r.loginSuccess) {
                        let userNurseLoginInfo = r.userNurseLoginInfo;
                        sessionStorage.setItem('userNurseLoginInfo', JSON.stringify(userNurseLoginInfo));
                    }
                }).catch(_ => {})
            } else {
                let baseURL = window.location.href;
                shortUrl({url: baseURL}).then(r => {
                    window.location.href = Config.wxUseUrl + 'hsjmp/mp/getCode?shareKey=' + r;
                }).catch(_ => {})
            }
        }
    }
}
